module.exports = __webpack_public_path__ + "static/img/2_1_2.71cce2c2.png";